import { AccountCircle, Build, Publish, QuestionAnswer, VerifiedUser, VpnKey, Warning } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React from "react";
import styled from "styled-components";
import { getClickButton } from "../../functions/getButtons";
import getUrl from "../../functions/getUrl";
import { getReturnUrlFromQueryString } from "../../functions/urlHandling";
import { IntegrationStatuses } from "./IntegrationStatuses";

const ActionRow = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 0.5em;
  & a {
    text-decoration: none;
  }
`;

const getReturnUrl = () => {
  return getReturnUrlFromQueryString() || getUrl("/partnership/integrations/my");
};

interface IIntegrationDetailActionRowProps {
  handleBeginDevelopment: () => void;
  handleSecuritySettings: () => void;
  handleSubmitForProduction: () => void;
  handleDiscontinue: () => void;
  handleQmlativAccess: () => void;
  isQmlativ: boolean;
  integrationStatusID: number;
}

export const IntegrationDetailActionRow = (props: IIntegrationDetailActionRowProps): JSX.Element => {
  const { isQmlativ, integrationStatusID } = props;

  const beginDevelopmentButton =
    isQmlativ && integrationStatusID === IntegrationStatuses.NotStarted && getClickButton("Begin Development", <Build />, props.handleBeginDevelopment);
  const securitySettingsButton =
    isQmlativ && integrationStatusID !== IntegrationStatuses.NotStarted && getClickButton("Security Settings", <VpnKey />, props.handleSecuritySettings);
  const submitForProductionButton =
    isQmlativ &&
    integrationStatusID === IntegrationStatuses.InDevelopment &&
    getClickButton("Submit for Production", <Publish />, props.handleSubmitForProduction);
  const qmlativAccessButton =
    isQmlativ && integrationStatusID !== IntegrationStatuses.NotStarted && getClickButton("View Qmlativ Access", <AccountCircle />, props.handleQmlativAccess);
  const discontinueButton = getClickButton("Discontinue", <Warning />, props.handleDiscontinue, "secondary");

  return (
    <ActionRow>
      {getClickButton("Back", <ArrowBackIcon />, () => window.location.replace(getReturnUrl()))}
      {getClickButton("What's an Integration", <QuestionAnswer />, () => window.location.replace(getUrl("/support/integration-definition")))}
      {integrationStatusID !== IntegrationStatuses.Discontinued && integrationStatusID !== IntegrationStatuses.Rejected && (
        <>
          {beginDevelopmentButton}
          {securitySettingsButton}
          {submitForProductionButton}
          {qmlativAccessButton}
          {discontinueButton}
        </>
      )}
    </ActionRow>
  );
};
